import React from "react";

export default function Banner({ children, className = "", altBG }) {
  const bgClass = altBG
    ? "bg-cover-image bg-rounded"
    : "bg-sunny-top-left bg-cover-image bg-rounded";

  const style = altBG
    ? {
        backgroundImage: `url(${altBG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : undefined;

  return (
    <section className={`${bgClass} ${className}`} style={style}>
      <div className="container">
        <div className="row align-items-center justify-content-between">
          {children}
        </div>
      </div>
    </section>
  );
}
